export default {
  methods: {
    sendEmail(
      to,
      subject,
      message,
      cc = [],
      bcc = [],
      hasAttachments = false,
      file = null
    ) {
      return new Promise(async (resolve, reject) => {
        let loader = this.$loading();
        try {
          const payload = {
            to,
            subject,
            message,
            cc,
            bcc,
          };
          if (hasAttachments) {
            const data = await this.sendEmailWithAttachments({
              ...payload,
              file: file,
            });
            resolve(data);
          } else {
            const { data } = await this.$store.dispatch(
              "email/sendEmail",
              payload
            );
            resolve(data);
          }

          loader.close();
        } catch (error) {
          if (error) {
            reject(error);
            loader.close();
          }
        }
      });
    },
    sendEmailWithAttachments(params) {
      return new Promise(async (resolve, reject) => {
        try {
          const { to, subject, message, cc, file } = params;

          const payload = new FormData();
          payload.append("to", to);
          payload.append("subject", subject);
          payload.append("message", message);
          payload.append("file", file);
          if (cc.length) {
            payload.append("to", to);
          }

          const { data } = await this.$store.dispatch(
            "email/sendEmailWithAttachment",
            payload
          );
          resolve(data);
        } catch (error) {
          if (error) {
            reject(error);
            loader.close();
          }
        }
      });
    },
    successAlert(text = "Email sent") {
      return this.$swal({
        title: "Email sent",
        text: "",
        icon: "success",
        showCancelButton: false,
        confirmButtonText: "Okay",
        confirmButtonColor: "#830c81",
        cancelButtonText: "",
      });
    },
  },
};
